import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      retry({ count: 1, delay: (_, retryCount) => {
        // Retry only idempotent GET requests to avoid duplicating POST/PUT/DELETE side effects
        if (request.method !== 'GET') {
          throw new Error('Non-GET request, skip retry');
        }
        return new Observable(subscriber => subscriber.next(retryCount));
      }}),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}
